import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import us from '../public/locales/en-us.json';
import es from '../public/locales/es-es.json';
import it from '../public/locales/it-it.json';

const env = process?.env?.ENVIRONMENT;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    // we init with resources
    resources: {
      // de,
      en: us,
      es,
      // fr,
      it,
      // no,
      // pl,
      // ro,
      // sv,
      // uk,
      us,
    },
    fallbackLng: 'en',
    // have a common namespace used around the full app
    fallbackNS: 'global',
    defaultNS: 'global',
    debug: env !== 'prod',
    returnObjects: true, // used for component translations. it passes the whole translated object to the guicomlib
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });

export const { t } = i18n;
export default i18n;
